import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    aiComparisonListList: [],
    aiComparisonListRecord: [],
    aiComparisonDropdownList: [],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const AIComparisonListReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AI_COMPARISON_LIST_REQUEST:
            return {
                ...state,
                Loading: true,
                validation_error: "",
                redirect_to_list: false,
            }
        case actionTypes.AI_COMPARISON_LIST_SERVER_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                showUpdateForm: false,
                showViewPage: false,
                aiComparisonListRecord: [],
                aiComparisonDropdownList: [],
            }    
        case actionTypes.AI_COMPARISON_LIST_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                aiComparisonListList: action.aiComparisonListList,
                showUpdateForm: false,
                showViewPage: false,
                aiComparisonListRecord: [],
            }
        case actionTypes.AI_COMPARISON_LIST_GET_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                aiComparisonListRecord: action.record,
                showUpdateForm: (action.actionType === 'update') ? true : false,
                showViewPage: (action.actionType === 'view') ? true : false
            }
        case actionTypes.AI_COMPARISON_LIST_DROPDOWN_SUCCESS:
            return {
                ...state,
                Loading: false,
                aiComparisonDropdownList: action.aiComparisonDropdownList,
            }  
        case actionTypes.AI_COMPARISON_LIST_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,
            }
        case actionTypes.HIDE_AI_COMPARISON_LIST_FEILD_VALIDATION_ERROR:
            if (state.validation_error && state.validation_error[action.feild_key])
                delete state.validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,

            }
        case actionTypes.REDIRECT_TO_AI_COMPARISON_LIST_LIST:
            return {
                ...state,
                redirect_to_list: true,
                showUpdateForm: false,
                showViewPage: false,
                validation_error: '',
                aiComparisonListRecord: [],
                aiComparisonDropdownList: [],
            }
        default:
            return state;
    }
}

export default AIComparisonListReducer;